import React, { useEffect } from "react";
import DashboardLayout from "../../../../src/layoutcontainers/DashboardLayout/index";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Stack,
  LinearProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../src/components/MaterialBox";
import { useState } from "react";
import MaterialButton from "../../../../src/components/MaterialButton";
import ConfirmationDialog from "../../../../src/components/Dialog/ConfirmationDialog";
import MaterialSnackbar from "../../../../src/components/MaterialSnackbar";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BASEURL from "../../../../src/pages/Utils/Baseurl";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../../src/components/MaterialInput";
import AddIcon from "@mui/icons-material/Add";
import loading from "../../../assest/images/loading.svg";
import error from "../../../assest/images/404.svg";
import MaterialSelect from "../../../components/MasterSelect";
import Swal from "sweetalert2";
import { Autocomplete, TextField } from "@mui/material";
import { useUserDetails } from "../../../context/auth";
import { Country } from "country-state-city";
const AddWeekOff = () => {
  const navigate = useNavigate();
  const { AccessData } = useUserDetails();
  const [id, setId] = useState(null);
  const [viewData, setViewData] = useState("");

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [weekoffData, setWeekoffData] = useState({
    location: "",
    weekoffDays: [],
    startDate: "",
    endDate: "",

    locationStatus: "unchecked",
    weekoffDaysStatus: "unchecked",
    startDateStatus: "unchecked",
    endDateStatus: "unchecked",
  });

  const [originalWeekoffData, setOriginalWeekoffData] = useState({
    location: "",
    weekoffDays: [],
    startDate: "",
    endDate: "",
  });

  const [resource, setResource] = useState({
    weekoffDays: [],
  });
  const weekoffOptions = [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
  ];

  useEffect(() => {
    onfilterData();
  }, [viewData]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    console.log("id:", id);
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const onWeekoffSubmit = async () => {
    const query = `
            mutation addweekoff($location:String!
 $startDate:String!
 $endDate:String!
 $weekoffDays:String!){
   AddWeekOff(input:{
     location:$location
     startDate:$startDate
     endDate:$endDate
     weekoffDays:$weekoffDays
   }){
     weekoffConfiguration{
       location
       startDate
       endDate
       weekoffDays
       lastUpdate
     }
   }
 }
`;

    const formattedWeekoffDays = weekoffData.weekoffDays.join(",");

    try {
      console.log("weekoffData.location:", weekoffData.location);

      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            location: weekoffData.location.value,
            startDate: weekoffData.startDate,
            endDate: weekoffData.endDate,
            weekoffDays: formattedWeekoffDays,
          },
        }),
      });

      console.log(
        "responsessss:",
        response.data.data.AddWeekOff.weekoffConfiguration
      );
      let result = response.data.data.AddWeekOff.weekoffConfiguration;
      if (result !== "") {
        navigate("/weekoff");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "WeekOff Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
      });
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message:
          "Sorry for the inconvenience. There was a network issue. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onEditWeekoffSubmit = async () => {
    const query = `
          mutation EditWeekOff($id: Int!, $input: weekOffInput!) {
            editWeekoff(id: $id, input: $input) {
              weekoffConfiguration {
                id
                location
                weekoffDays
                startDate
                endDate
              }
            }
          }
        `;
    const formattedWeekoffDays = weekoffData.weekoffDays.join(",");
    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id, // Pass the id
            input: {
              // Pass input as an object matching weekOffInput
              location: weekoffData.location.value,
              weekoffDays: formattedWeekoffDays,
              startDate: "2024-12-27",
              endDate: "2024-12-27",
            },
          },
        }),
      });

      console.log(
        "responsesss:",
        response.data.data.editWeekoff.weekoffConfiguration
      );

      let result = response.data.data.editWeekoff.weekoffConfiguration;

      if (result !== "") {
        navigate("/weekoff");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "WeekOff Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }

      // Check if there's an error in the response
      if (response.data.errors) {
        throw new Error(response.data.errors[0].message);
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      setSnackBar({
        ...snackBar,
        Success: true,
      });
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteWeekoff();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteWeekoff = async () => {
    const query = `
   mutation deleteWeekoff($id: String!) {
  deleteWeekoffConfiguration(id: $id) {
    success
  }
}
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });
      if (response.data.data.deleteWeekoffConfiguration.success) {
        console.log("Weekoff deleted successfully!");
        navigate("/weekoff");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "WeekOff Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        console.log(
          "Error deleting Weekoff:",
          response.data.data.deleteWeekoffConfiguration.message
        );
      }
    } catch (error) {
      console.error("An error occurred while deleting the Weekoff:", error);
    }
  };

  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });

    const query = `query getWeekoffById($id: String!) {
      weekoffById(id: $id) {
        id
        location
        weekoffDays
        startDate
        endDate
      }
    }`;

    try {
      // Redundant set, but included if you want to ensure loading state is true
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const weekoffRowdata = response.data?.data?.weekoffById;

      // Safely handle if weekoffRowdata is null/undefined
      if (!weekoffRowdata) {
        throw new Error("weekoffById returned null or undefined.");
      }

      // Safely split and filter out empty strings
      const weekoffdays = (weekoffRowdata.weekoffDays || "")
        .split(",")
        .map((day) => day.trim())
        .filter((day) => day !== "");

      console.log("weekoffRowdata:", weekoffRowdata);
      console.log("weekoffdays:", weekoffdays);

      setWeekoffData({
        location: {
          value: weekoffRowdata.location,
          label: weekoffRowdata.location,
        },
        weekoffDays: weekoffdays,
        startDate: weekoffRowdata.startDate,
        endDate: weekoffRowdata.endDate,
        locationStatus : 'success',
        weekoffDaysStatus : 'success',
        startDateStatus : 'success',
        endDateStatus : 'success',
      });

      setOriginalWeekoffData({
        location: weekoffRowdata.location,
        weekoffDays: weekoffdays,
        startDate: weekoffRowdata.startDate,
        endDate: weekoffRowdata.endDate,
      });

      setTogglePage({
        ...togglePage,
        view: true,
      });

      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);

      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog((prev) => ({
            ...prev,
            open: false,
          }));
        },
      });
    }
  };

  // const handleweekoofchange = (event, selectEvent) => {
  //   console.log("selectEvent:", selectEvent, event?.label);
  //   let weekoffState = { ...weekoffData };

  //   if (!event?.target && selectEvent) {
  //     // Handling multi-select for weekoffDays
  //     if (selectEvent.name === "weekoffDays") {
  //       const selectedDays = event;
  //       console.log("selectedDays:", selectedDays);

  //       weekoffState["weekoffDaysStatus"] =
  //         selectedDays.length > 0 ? "success" : "unchecked";

  //       weekoffState["weekoffDays"] = selectedDays.map((day) => day.value); // Store only labels (days)
  //     } else if (selectEvent === "country") {
  //       if (event) {
  //         weekoffState["locationStatus"] = "success"
  //         // Store only labels (days)
  //         weekoffState["location"] = event;
  //       }

  //     }
  //   } else {
  //     const changeAllowed = true;
  //     switch (event.target.name) {
  //       case "location":
  //         {
  //           const loacRegex = new RegExp("^([\\s\\S]{5,500})$");

  //           if (loacRegex.test(event.target.value?.trim())) {
  //             weekoffState[event.target.name + "Status"] = "success";
  //           } else {
  //             weekoffState[event.target.name + "Status"] =
  //               event.target.value === "" ? "unchecked" : "error";
  //           }
  //         }
  //         break;

  //       case "startDate":
  //         {
  //           const dateLengthRegex = new RegExp(
  //             "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
  //           );
  //           if (dateLengthRegex.test(event.target.value?.trim())) {
  //             weekoffState[event.target.name + "Status"] = "success";
  //           } else {
  //             weekoffState[event.target.name + "Status"] =
  //               event.target.value === "" ? "unchecked" : "error";
  //           }
  //         }
  //         break;

  //       case "endDate":
  //         {
  //           const dateLengthRegex = new RegExp(
  //             "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
  //           );

  //           if (dateLengthRegex.test(event.target.value?.trim())) {
  //             weekoffState[event.target.name + "Status"] = "success";
  //           } else {
  //             weekoffState[event.target.name + "Status"] =
  //               event.target.value === "" ? "unchecked" : "error";
  //           }
  //         }
  //         break;
  //     }
  //     weekoffState[event.target.name] = event.target.value;
  //   }
  //   setWeekoffData(weekoffState);
  // };

  const handleweekoofchange = (event, selectEvent) => {
    console.log("selectEvent:", selectEvent, event?.label);
    let weekoffState = { ...weekoffData };

    if (!event?.target && selectEvent) {
      // Handling multi-select for weekoffDays
      if (selectEvent.name === "weekoffDays") {
        const selectedDays = event;

        if (selectedDays.length > 2) {
          alert("You can select only 2 days");
          return; // Stop further execution
        }

        console.log("selectedDays:", selectedDays);

        weekoffState["weekoffDaysStatus"] =
          selectedDays.length > 0 ? "success" : "unchecked";

        weekoffState["weekoffDays"] = selectedDays.map((day) => day.value); // Store only labels (days)
      } else if (selectEvent === "country") {
        if (event) {
          weekoffState["locationStatus"] = "success";
          weekoffState["location"] = event;
        }
      }
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "location":
          {
            const loacRegex = new RegExp("^([\\s\\S]{5,500})$");

            if (loacRegex.test(event.target.value?.trim())) {
              weekoffState[event.target.name + "Status"] = "success";
            } else {
              weekoffState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "startDate":
        case "endDate":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (dateLengthRegex.test(event.target.value?.trim())) {
              weekoffState[event.target.name + "Status"] = "success";
            } else {
              weekoffState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      weekoffState[event.target.name] = event.target.value;
    }
    setWeekoffData(weekoffState);
  };
  const handleAddWeekOff = () => {
    // setPageState({
    //   ...pageState,
    //   state: "submitting",
    // });
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onWeekoffSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };
  const handlediscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to discard your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardWeekoff();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onDiscardWeekoff = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setWeekoffData({
      location: {
        value: originalWeekoffData.location,
        label: originalWeekoffData.location,
      },
      weekoffDays: originalWeekoffData.weekoffDays,
      startDate: originalWeekoffData.startDate,
      endDate: originalWeekoffData.endDate,
    });
    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
  };

  const onfilterData = () => {
    const filterWeekoff = resource.weekoffDays.filter(
      (weekoff) => weekoff.weekoffDays == viewData
    );
    console.log(
      "filterWeekoff:",
      viewData,
      resource.weekoffDays,
      filterWeekoff
    );

    setWeekoffData({
      ...weekoffData,
      weekoffDays: filterWeekoff.map((weekoff) => {
        return {
          value: weekoff.id,
          label: weekoff.weekoffDays,
        };
      }),
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      weekoffData.locationStatus === "success" &&
      weekoffData.weekoffDaysStatus === "success" &&
      weekoffData.startDateStatus === "success" &&
      weekoffData.endDateStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      weekoffData.location === originalWeekoffData.location &&
      weekoffData.weekoffDays === originalWeekoffData.weekoffDays &&
      weekoffData.startDate === originalWeekoffData.startDate &&
      weekoffData.endDate === originalWeekoffData.endDate
    ) {
      allowSubmit = false;
    } else if (weekoffData.location !== originalWeekoffData.location) {
      if (weekoffData.locationStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (weekoffData.weekoffDays !== originalWeekoffData.weekoffDays) {
      if (weekoffData.weekoffDaysStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    }
    // else if (weekoffData.startDate !== originalWeekoffData.startDate) {
    //   if (weekoffData.startDateStatus === "success") {
    //     allowSubmit = true;
    //   } else {
    //     allowSubmit = false;
    //   }
    // }
    // else if (weekoffData.endDate !== originalWeekoffData.endDate) {
    //   if (weekoffData.endDateStatus === "success") {
    //     allowSubmit = true;
    //   } else {
    //     allowSubmit = false;
    //   }
    // }
    else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/weekoff");
  };


  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the Weekoff details for you. This
                    may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true || togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Weekoff Details
                      </MaterialTypography>
                    </Stack>
                    {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "EditWeekOff" && item.can_access
                      ) &&
                      pageState.state !== "submitting" && (
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>

                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add WeekOff
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent
            sx={{
              minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
            }}
          >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img
                      src={error}
                      alt="error"
                      style={{
                        width: "30%",
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}
            {pageState.state === "default" && !pageState.loading && (
              <MaterialBox>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Location <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                      name="location"
                      placeholder="Select..."
                      value={weekoffData.location}
                      onChange={(e) => handleweekoofchange(e, "country")}
                      options={Country.getAllCountries().map((value) => {
                        return {
                          value: value?.name,
                          label: value?.name,
                          isoCode: value?.isoCode,
                        };
                      })}
                      error={weekoffData.locationStatus === "error"}
                      success={weekoffData.locationStatus === "success"}
                      isDisabled={togglePage.view === true ? true : false}
                    />
                  </Grid>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        WeekOff <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>

                    <Autocomplete
                      multiple
                      options={weekoffOptions}
                      value={weekoffData.weekoffDays.map((day) => ({
                        value: day,
                        label: day,
                      }))} // Map state values back to objects
                      onChange={(event, newValue) =>
                        handleweekoofchange(newValue, { name: "weekoffDays" })
                      }
                      getOptionLabel={(option) => option.label}
                      disabled={togglePage.view === true}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Choose up to 2 days"
                          error={weekoffData.weekoffDays.length > 2} // Show error if more than 2 days
                          helperText={
                            weekoffData.weekoffDays.length > 2
                              ? "You can select only 2 days"
                              : ""
                          }
                        />
                      )}
                    />
                  </Grid>

                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Valid From <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="startDate"
                      placeholder="eg. IT"
                      type="date"
                      inputProps={{
                        min: new Date().toISOString().split("T")[0],
                      }}
                      value={weekoffData.startDate}
                      onChange={handleweekoofchange}
                      error={weekoffData.startDateStatus === "error"}
                      success={weekoffData.startDateStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                    />
                  </Grid>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Valid Till <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="endDate"
                      value={weekoffData.endDate}
                      type="date"
                      inputProps={{
                        min: new Date().toISOString().split("T")[0],
                      }}
                      onChange={handleweekoofchange}
                      error={weekoffData.endDateStatus === "error"}
                      success={weekoffData.endDateStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                    />
                  </Grid>
                </Grid>
              </MaterialBox>
            )}
          </CardContent>
          {pageState.state !== "submitting" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={handlediscard}
                  >
                    Discard
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={
                      !checkAllFields() || pageState.state === "submitting"
                    }
                    onClick={onEditWeekoffSubmit}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                 <MaterialButton
                            sx={{ m: 2 }}
                            variant="gradient"
                            color="dark"
                           onClick={handlecancel}
                           
                          >
                            Cancel
                          </MaterialButton>
                          <MaterialButton
                  sx={{ m: 2 ,marginLeft:'4px' }}
                  variant="gradient"
                  color="dark"
                  disabled={
                    !checkAllFields() || pageState.state === "submitting"
                  }
                  // startIcon={<AddIcon />}
                  onClick={handleAddWeekOff}
                >
                  Submit
                </MaterialButton>
              </>
              
              ) : null}
            </MaterialBox>
          )}
          {
            <MaterialSnackbar
              color="success"
              icon={<NotificationsIcon />}
              title="Message"
              content="You have been submitted successfully"
              open={snackBar.Success}
              close={() =>
                setSnackBar({
                  success: false,
                })
              }
            />
          }
        </Card>
      )}
    </DashboardLayout>
  );
};

export default AddWeekOff;
